import OrderService from '../../services/order.service';

const orderModule = {
  namespaced: true,
  state: {
    name: '',
    phone: '',
    email: '',
    organization: '',
    clientType: 10,
    receiving: 10,
    payment: 10,
    deliveryCompany: null,
    comment: '',
    address: '',
    isAddressOk: false,
    pickupPoint: null,
    deliveryCompanyPoint: null,
    parcelShop: null,
    inn: '',
    deliveryPrice: 0,
    daDataResult: {},
    errors: {
      name: [],
      phone: [],
      email: [],
      delivery: [],
      addressFilled: [],
      addressOk: [],
      tkFilled: [],
      pickupPointSelected: [],
      inn: [],
    },
    redirectBaseUrl: '/cart/success',
    redirectCreditUrl: '/cart/credit',
    redirectPaymentUrl: '/cart/pay'
  },
  getters: {
    isPickup(state) {
      return state.receiving === 10;
    },
    isDelivery(state) {
      return state.receiving === 20;
    },
    isPhysical(state) {
      return state.clientType === 10;
    },
    isLegal(state) {
      return state.clientType === 20;
    }
  },
  actions: {
    async send({ state, dispatch, commit }, isFast) {
      try {
        const result = isFast ? await OrderService.fastSave(state) : await OrderService.save(state);
        if (result.data.errors) {
          commit('setErrors', result.data.errors)
          dispatch('notification/showErrorNotification', 'Не заполнены обязательные поля', {root:true});
        } else if (result.data.payment === 10 || result.data.payment === 20) {
          dispatch('redirectToPaymentPage', result)
        } else if (!isFast) {
          dispatch('redirectToSuccessPage', result)
        }
        return true;
      } catch (error) {
        dispatch('notification/showErrorNotification', 'Произошла ошибка', {root:true});
      }
      return false;
    },
    redirectToSuccessPage({state, dispatch, commit}, result) {
      const orderFromBasket = 20;
      window.location.pathname = `${state.redirectBaseUrl}/${result.data.order_id}/${orderFromBasket}`;
    },
    redirectToCreditPage({state, dispatch, commit}, result) {
      window.location.pathname = `${state.redirectCreditUrl}/${result.data.order_id}`;
    },
    redirectToPaymentPage({state, dispatch, commit}, result) {
      window.location = result.data.payLink;
    }
  },
  mutations: {
    setReceiving(state, value) {
      state.receiving = value;
    },
    setPayment(state, value) {
      state.payment = value;
    },
    setClientType(state, value) {
      state.clientType = value;
    },
    setName(state, value) {
      state.name = value;
    },
    setPhone(state, value) {
      state.phone = value;
    },
    setEmail(state, value) {
      state.email = value;
    },
    setAddress(state, value) {
      state.address = value;
    },
    setIsAddressOk(state, value) {
      state.isAddressOk = value;
    },
    setDaDataResult(state, value) {
      state.daDataResult = value
    },
    setDeliveryCompany(state, value) {
      state.deliveryCompany = value;
    },
    setDeliveryPrice(state, value) {
      state.deliveryPrice = value;
    },
    setOrganization(state, value) {
      state.organization = value;
    },
    setInn(state, value) {
      state.inn = value;
    },
    setPickupPoint(state, value) {
      state.pickupPoint = value;
    },
    setDeliveryCompanyPoint(state, value) {
      state.deliveryCompanyPoint = value;
    },
    setParcelShop(state, value) {
      state.parcelShop = value;
    },
    setComment(state, value) {
      state.comment = value;
    },
    setErrors(state, value) {
      state.errors = value
    }
  },
};

export default orderModule;